export default "__VITE_ASSET__ciVTnxs4__"